import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { DeviceCommentUpdate } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<
      unknown,
      Error,
      { deviceId: string; payload: DeviceCommentUpdate },
      unknown
    >,
    'mutationKey' | 'mutationFn'
  >
}

export const usePatchDataLoggerRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { deviceId: string; payload: DeviceCommentUpdate }, unknown>(
    [Entities.DataLoggers, 'patch'],
    async ({ deviceId, payload }) => {
      const { data } = await api.v1AdminDataLoggersDeviceIdPatch(deviceId, payload)
      return data
    },
    { ...options }
  )
}
